// Key values that are repeated a lot
import { defaultFieldLogic } from 'AppSrc/core/components/forms/form-base-components/data-structure/default-field-logic';
// sub section titles
import { ciUnavailabilityDetails } from './section-title';
// form fields
import { ciUnavailabilityItems } from './ci-unavailability-items';

const selectedNetwork = 'mobile';
const getSectionCiCurrentFields = () => {
  const currentFields = [
    {
      ...defaultFieldLogic,
      componentData: {
        ...ciUnavailabilityDetails,
      },
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...ciUnavailabilityItems,
        vFParams: {
          ...ciUnavailabilityItems.vFParams,
          selectedNetwork,
        },
      },
      shouldValidate: true,
    },
  ];
  return currentFields;
};

export {
  getSectionCiCurrentFields,
};
